/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';

export class HostedFileService {

    /**
     * @param orderId 
     * @param orderlineId 
     * @param formData 
     * @returns any Success
     * @throws ApiError
     */
    public static postOrderOrderlineHostedFile(
orderId: number,
orderlineId: number,
formData?: {
file?: Blob;
},
): CancelablePromise<any> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/order/{orderId}/Orderline/{orderlineId}/HostedFile',
            path: {
                'orderId': orderId,
                'orderlineId': orderlineId,
            },
            formData: formData,
            mediaType: 'multipart/form-data',
        });
    }

    /**
     * @param orderId 
     * @param orderlineId 
     * @param formData 
     * @returns any Success
     * @throws ApiError
     */
    public static postOrderOrderlineHostedFileUploadhostedfile(
orderId: number,
orderlineId: number,
formData?: {
file?: Blob;
},
): CancelablePromise<any> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/order/{orderId}/Orderline/{orderlineId}/HostedFile/uploadhostedfile',
            path: {
                'orderId': orderId,
                'orderlineId': orderlineId,
            },
            formData: formData,
            mediaType: 'multipart/form-data',
        });
    }

    /**
     * @param orderlineId 
     * @param orderId 
     * @returns any Success
     * @throws ApiError
     */
    public static getOrderOrderlineHostedFileAll(
orderlineId: number,
orderId: string,
): CancelablePromise<any> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/order/{orderId}/Orderline/{orderlineId}/HostedFile/all',
            path: {
                'orderlineId': orderlineId,
                'orderId': orderId,
            },
        });
    }

    /**
     * @param orderlineId 
     * @param hostedFileId 
     * @param orderId 
     * @returns any Success
     * @throws ApiError
     */
    public static getOrderOrderlineHostedFile(
orderlineId: number,
hostedFileId: number,
orderId: string,
): CancelablePromise<any> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/order/{orderId}/Orderline/{orderlineId}/HostedFile/{hostedFileId}',
            path: {
                'orderlineId': orderlineId,
                'hostedFileId': hostedFileId,
                'orderId': orderId,
            },
        });
    }

    /**
     * @param orderlineId 
     * @param orderId 
     * @param hostedFileIds 
     * @returns any Success
     * @throws ApiError
     */
    public static getOrderOrderlineHostedFileZip(
orderlineId: number,
orderId: string,
hostedFileIds?: string,
): CancelablePromise<any> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/order/{orderId}/Orderline/{orderlineId}/HostedFile/Zip',
            path: {
                'orderlineId': orderlineId,
                'orderId': orderId,
            },
            query: {
                'hostedFileIds': hostedFileIds,
            },
        });
    }

    /**
     * @param hostedFileId 
     * @param size 
     * @param filetype 
     * @param orderId 
     * @param orderlineId 
     * @returns any Success
     * @throws ApiError
     */
    public static getOrderOrderlineHostedFileThumbnail(
hostedFileId: number,
size: number,
filetype: string,
orderId: string,
orderlineId: string,
): CancelablePromise<any> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/order/{orderId}/Orderline/{orderlineId}/HostedFile/{hostedFileId}/thumbnail/{size}/{filetype}',
            path: {
                'hostedFileId': hostedFileId,
                'size': size,
                'filetype': filetype,
                'orderId': orderId,
                'orderlineId': orderlineId,
            },
        });
    }

}
